import React from 'react';
import styles from  './countdown.module.css';
import girlLogo from '../../assets/girl.svg';
import Countdown from '../../components/Countdown';
import { useGameSocket } from '../../providers/gameSocket.provider';
import WaitingForHost from '../../components/WaitingForHostLoader';
import { useNavigate, useParams } from 'react-router-dom';
// import { Question } from '../../types/Question';
// import { Round } from '../../types/Round';
// import { useRecorderPermission } from '../../hooks/useRecorderPermission';
import { GameRoundResponse } from '../../services/MtcBackendClient/types/response/game.response';
import ElemGameScreen from '../ElemGamescreen.tsx';
import { parseError } from '../../utils/errorUtils';
import ToastContext from '../../contexts/ToastContext';
import GamePreviewScreen from '../GamePreviewScreen';
type GameView = 'challenge' | 'rule' | 'countdown' | 'game';


const ElementaryCountdownScreen: React.FC<any> = ()=>{

    // Ref
    let isRendered = React.useRef<boolean>(false);
    let exceptionDisplayed = React.useRef<boolean>(false);

    // Context
    const { openError } = React.useContext(ToastContext)

    // Hooks
    const { gameSocket } = useGameSocket();
    const { rid, host } = useParams();
    // const recorder = useRecorderPermission('video');
    const navigate = useNavigate()

    // State
    const [begin, setBegin] = React.useState<boolean>(false);
    const [waitingForPlayer, setWaitingForPlayer] = React.useState<boolean>(true);
    const [view, setView] = React.useState<GameView>('challenge');
    const [game, setGame] = React.useState<GameRoundResponse>(); 


    // Handlers
    const onZeroCallback = ()=>{
        // alert("WE ARE LIVE");
        setView('game');
        // history.push('/game');
    }

    // Effect
    React.useEffect(()=>{
        if (!isRendered.current) {
            gameSocket?.emit('join-round', rid)
            
            gameSocket?.on('connect', ()=>{
                if (rid) {
                    console.log("CONNECTED RID")
                    gameSocket.emit('join-round', rid)
                }
            })
    
            gameSocket?.on('ready', ()=>{
                setWaitingForPlayer(false);
                // if (!recorder) {
                //     alert("Game cannot be played without recorder permission");
                //     navigate('/')
                // }
            })

            gameSocket?.on('game-loaded', (gameData: GameRoundResponse)=>{
                console.log("Game loaded")
                setGame(gameData)
                setView("challenge")
            })

            gameSocket?.on('game-continued', (gameData: GameRoundResponse)=>{
                setView("countdown")
            })
    
            gameSocket?.on('start', (gameData: GameRoundResponse)=>{
                setBegin(true);
                // console.log(round.name);
                // console.log(JSON.stringify(gameData?.questions))
                setGame(gameData)
            })
            gameSocket?.on('exception', (e: any)=>{
                if (!exceptionDisplayed.current) {
                    console.log(e);
                    openError(parseError(e))
                    exceptionDisplayed.current = true;
                }
            })
            isRendered.current = true;
        }
        
    },[])

    // Elements
    const countdownScreen = (
        <div className={styles.container} >
            { waitingForPlayer && <WaitingForHost/> }
            {/** Ready Text */}
            <div className={styles.title}>
                <h1>Ready</h1>
                <img src={girlLogo} alt="" />
            </div>
            
            {/** Countdown */}
            <Countdown begin={begin} onZeroCallback={onZeroCallback}/>

        </div>
    )


    return(
        <>
        { 
            view === 'challenge' 
            && 
            <GamePreviewScreen
                round={game?.round}
            /> 
        }
        { view === 'countdown' && countdownScreen }
        {
            view === 'game' && game  && host &&
            <ElemGameScreen
                round={game.round}
                questions={game.questions}
                onGoBack={()=> setView('countdown')}
                //recorder={recorder}
                code={host}
            />
        }
        </>
    )
}

export default ElementaryCountdownScreen;